// extracted by mini-css-extract-plugin
export default {"label-value":"adc__label-value--xIp8I","divider":"adc__divider--QrYZw"};